import { Identifier, IShipmentType } from '@src/models/api';
import { getGlobalRequestTimeout } from '../config/timeout';

export const REQUEST_TIMEOUT = getGlobalRequestTimeout();
export const B2B_HOMEPAGE_PATH = '/b2b/account/view/homepage/';
export const RETURN_SUMMARY_SESSION_STORAGE_KEY = 'returnSummaryData';
export const SSR_SESSION_STORAGE_KEY = 'orderDetailsData';
export const RETURN_METHOD = {
  IN_STORE: 'In-Store',
  SORIS: 'SORIS',
  UPS_DROP_OFF: 'UPS',
  LORP: 'LORP',
  APO_FPO: 'APO_FPO',
} as const;
export type ReturnMethodType =
  (typeof RETURN_METHOD)[keyof typeof RETURN_METHOD];

export const MAX_WEIGHT_LIMIT = 150;

export enum ReturnMethodErrorType {
  WEIGHT_LIMIT_EXCEEDED = 'WEIGHT_LIMIT_EXCEEDED',
}

export const ITEM_IMG_SIZE = 48;
export const STATE_CODE_TO_NAME_MAP = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
  DC: 'District of Columbia',
  AS: 'American Samoa',
  GU: 'Guam',
  MP: 'Northern Mariana Islands',
  PR: 'Puerto Rico',
  VI: 'US Virgin Islands',
  UM: 'US Minor Outlying Islands',
};

export const US_TERRITORIES = new Set([
  'DC',
  'AS',
  'GU',
  'MP',
  'PR',
  'VI',
  'UM',
]);

export const SHIPMENT_TO_RETURN_METHOD_MAP: {
  [key in IShipmentType]: ReturnMethodType;
} = {
  PICKUP: RETURN_METHOD.LORP,
  DROPOFF: RETURN_METHOD.UPS_DROP_OFF,
  PHASE_0_SORIS: RETURN_METHOD.IN_STORE,
  SORIS: RETURN_METHOD.SORIS,
};

export const RETURN_METHOD_TO_SHIPMENT_MAP: {
  [key in ReturnMethodType]: IShipmentType;
} = {
  [RETURN_METHOD.LORP]: 'PICKUP',
  [RETURN_METHOD.UPS_DROP_OFF]: 'DROPOFF',
  [RETURN_METHOD.IN_STORE]: 'PHASE_0_SORIS',
  [RETURN_METHOD.SORIS]: 'SORIS',
  [RETURN_METHOD.APO_FPO]: 'DROPOFF', // Mapping to dropoff to satisfy the typing, no shipments will be created for APO/FPO return methods
};

// Methods that are handled client-side only (no PolicyValidator or ReturnCreate API calls)
export const isClientSideOnlyMethod = (method: ReturnMethodType | undefined) =>
  method === RETURN_METHOD.IN_STORE || method === RETURN_METHOD.APO_FPO;

export const shipmentTypeToIdentifierMap: Record<IShipmentType, Identifier> = {
  PICKUP: '1',
  DROPOFF: '2',
  SORIS: '3',
  PHASE_0_SORIS: '3',
};
